import { useEffect, useState } from 'react'
import { Befehlsnachricht } from '@/models/Befehlsnachricht'
import { verifyBefehlsnachricht } from '@/features/befehlsnachrichten/utils/verification'

export const useBefehlsnachrichtHashVerification = (
  befehlsnachricht?: Befehlsnachricht
) => {
  const [isHashValid, setIsHashValid] = useState<boolean | null>(null)

  useEffect(() => {
    const verifyHash = async () => {
      if (befehlsnachricht) {
        verifyBefehlsnachricht(befehlsnachricht)
          .then((isValid: boolean) => {
            setIsHashValid(isValid)
          })
          .catch(() => {
            setIsHashValid(false)
          })
      } else {
        setIsHashValid(false)
      }
    }

    verifyHash()
  }, [befehlsnachricht])

  return { isHashValid }
}
